import styled from 'styled-components';

export const Container = styled.footer`
  width: 100%;

  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 2rem;

  padding: 3.5rem 7rem;

  > div {
    width: 10.875rem;
  }

  @media (max-width: 1919px) {
    padding: 3.5rem 5rem;
  }

  @media (max-width: 1200px) {
    padding: 3.5rem 3rem;
  }

  @media (max-width: 500px) {
    padding: 1.5rem 2rem;
  }
`;

export const SiteContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  gap: 2rem;

  img {
    height: 2rem;
  }

  p,
  span {
    font-size: 1rem;
    line-height: 1.6rem;
    font-weight: 400;
  }

  p {
    color: ${({ theme }) => theme.colors.gray6};
  }

  span {
    color: ${({ theme }) => theme.colors.gray5};
  }
`;

export const CompanyContent = styled.div`
  h3 {
    font-size: 1rem;
    line-height: 1.5rem;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.08em;

    color: ${({ theme }) => theme.colors.primary};

    margin-bottom: 1.25rem;
  }

  p {
    font-size: 1rem;
    line-height: 1.5rem;
    font-weight: 500;

    color: ${({ theme }) => theme.colors.gray4};

    cursor: pointer;
  }

  p + p,
  p + a,
  a + p,
  > a + a {
    display: block;

    margin-top: 1rem;
  }

  a {
    font-size: 1rem;
    line-height: 1.5rem;
    font-weight: 500;

    color: ${({ theme }) => theme.colors.gray6};

    transition: color 0.2s;

    &:hover {
      color: ${({ theme }) => theme.colors.gray8};
    }
  }
`;

export const SocialMediaContent = styled.div`
  display: flex;
  flex-direction: row;
  gap: 1rem;

  margin-bottom: 2.5rem;

  svg {
    width: 2rem;
    height: 2rem;

    color: ${({ theme }) => theme.colors.gray4};

    transition: color 0.2s;
  }

  svg:hover {
    color: ${({ theme }) => theme.colors.gray7};
  }
`;

export const WorkContent = styled.div`
  a {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: start;
  }

  p {
    font-size: 1rem !important;
    line-height: 1.6rem !important;
    font-weight: 600 !important;

    text-decoration-line: underline;
    text-underline-offset: 0.25rem;

    color: ${({ theme }) => theme.colors.gray5} !important;

    cursor: pointer !important;

    margin-left: 0.5rem;

    transition: color 0.2s;

    &:hover {
      color: ${({ theme }) => theme.colors.gray7} !important;
    }
  }
`;
